export const CONEKTA_PUBLIC_KEYS = {
    "UERRE": process.env.REACT_APP_CONEKTA_UERRE_KEY,
    "UNID": process.env.REACT_APP_CONEKTA_UNID_KEY,
    "HH": process.env.REACT_APP_CONEKTA_HH_KEY
};